module.exports = __webpack_public_path__ + "files/3f49cb64038f10dd5bb74835892ae293.png";